import LegalLayout from "@/pages/LegalLayout";

export default function Privacy() {
  return (
    <LegalLayout testId="privacy-page" title="Privacy Policy" updated="Dicembre 2025">
      <p>
        La presente informativa descrive le modalità con cui Social Whale tratta i dati personali
        raccolti tramite il sito <a href="https://socialwhale.it">socialwhale.it</a> e i canali
        di contatto (email, telefono) ai sensi del Regolamento UE 2016/679 (GDPR)
        e del D.lgs. 196/2003.
      </p>

      <h2>1. Titolare del trattamento</h2>
      <p>
        Il titolare del trattamento è Social Whale. Per qualunque richiesta relativa ai tuoi
        dati puoi scriverci a <a href="mailto:info@socialwhale.it">info@socialwhale.it</a>{" "}
        o chiamarci al <a href="tel:+393513269205">+39 351 326 9205</a>.
      </p>

      <h2>2. Tipologia di dati raccolti</h2>
      <ul>
        <li><strong>Dati di contatto:</strong> nome, email, numero di telefono forniti tramite il form di contatto o il quiz.</li>
        <li><strong>Dati di navigazione:</strong> IP anonimizzato, tipo di browser, pagine visitate, tempi di permanenza (solo con consenso ai cookie analitici).</li>
        <li><strong>Dati facoltativi:</strong> informazioni sul tuo brand che ci fornisci volontariamente nel messaggio.</li>
      </ul>

      <h2>3. Finalità e base giuridica</h2>
      <ul>
        <li><strong>Rispondere alle tue richieste</strong> (art. 6.1.b GDPR – esecuzione di misure precontrattuali).</li>
        <li><strong>Inviarti una proposta commerciale</strong> personalizzata (base giuridica: tuo consenso, art. 6.1.a).</li>
        <li><strong>Adempiere ad obblighi di legge</strong> fiscali e contabili (art. 6.1.c).</li>
        <li><strong>Migliorare il sito e i nostri servizi</strong> tramite dati aggregati e anonimi (legittimo interesse, art. 6.1.f).</li>
      </ul>

      <h2>4. Conservazione dei dati</h2>
      <p>
        I dati raccolti tramite form vengono conservati per il tempo necessario a gestire la
        richiesta e comunque non oltre 24 mesi in assenza di rapporto contrattuale. In caso di
        avvio di collaborazione, i dati sono conservati per l&apos;intera durata del rapporto e
        per i 10 anni successivi ai fini fiscali.
      </p>

      <h2>5. Destinatari e trasferimenti</h2>
      <p>
        I dati possono essere trattati dai membri del team Social Whale e da fornitori terzi che
        agiscono come Responsabili del trattamento (es. servizi di hosting, invio email
        transazionali via Resend). Non trasferiamo i tuoi dati fuori dallo Spazio Economico
        Europeo senza adeguate garanzie contrattuali.
      </p>

      <h2>6. I tuoi diritti</h2>
      <p>
        Puoi in qualsiasi momento esercitare i diritti previsti dagli artt. 15-22 GDPR: accesso,
        rettifica, cancellazione, limitazione, portabilità e opposizione. Per esercitarli
        scrivi a <a href="mailto:info@socialwhale.it">info@socialwhale.it</a>.
        Hai inoltre diritto di proporre reclamo al Garante per la protezione dei dati personali
        (<a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer">garanteprivacy.it</a>).
      </p>

      <h2>7. Sicurezza</h2>
      <p>
        Adottiamo misure tecniche e organizzative adeguate a proteggere i tuoi dati da accessi
        non autorizzati, perdita o divulgazione: password cifrate, connessioni HTTPS, accessi
        limitati al personale strettamente necessario.
      </p>

      <h2>8. Modifiche</h2>
      <p>
        Questa informativa può essere aggiornata per esigenze normative o operative. Ti invitiamo
        a consultarla periodicamente: la data in alto riporta sempre l&apos;ultima revisione.
      </p>
    </LegalLayout>
  );
}
